import { render, staticRenderFns } from "./MyLoanRejected.vue?vue&type=template&id=3a55a4c6&"
import script from "./MyLoanRejected.vue?vue&type=script&lang=js&"
export * from "./MyLoanRejected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports